// ═══ SOLÈY GUMMIES - PDP INTERACTIVE SCRIPT (twd-2.js) ═══

// 2. GALLERY IMAGE SWITCHER & SWIPE
let activeImgIndex = 0;

function switchImg(idx) {
  const mainImgs = document.querySelectorAll('#mainImg, .gallery-img-primary, .gallery-img');
  const thumbs = document.querySelectorAll('.gt');

  mainImgs.forEach((img, i) => {
    img.style.opacity = (i === idx) ? '1' : (mainImgs.length === 1 ? '1' : '0');
  });

  thumbs.forEach((t, i) => {
    t.classList.toggle('active', i === idx);
  });

  activeImgIndex = idx;
}

// Touch swipe support for gallery
document.addEventListener('DOMContentLoaded', function() {
  const galleryWrap = document.querySelector('.gallery-main-wrap, .gallery-main');
  if (galleryWrap) {
    let startX = 0;
    galleryWrap.addEventListener('touchstart', e => {
      if (e.touches && e.touches[0]) startX = e.touches[0].clientX;
    }, { passive: true });

    galleryWrap.addEventListener('touchend', e => {
      if (!e.changedTouches || !e.changedTouches[0]) return;
      const diffX = e.changedTouches[0].clientX - startX;
      const totalThumbs = document.querySelectorAll('.gt').length;
      if (Math.abs(diffX) > 40 && totalThumbs > 1) {
        if (diffX < 0) {
          switchImg(Math.min(activeImgIndex + 1, totalThumbs - 1));
        } else {
          switchImg(Math.max(activeImgIndex - 1, 0));
        }
      }
    }, { passive: true });
  }
});

// 3. OFFER SELECTOR SYSTEM
let selectedOfferIdx = 0;

function selectOffer(el, typeOrIdx) {
  const options = document.querySelectorAll('.offer-opt');
  options.forEach((opt, i) => {
    const isTarget = (typeof typeOrIdx === 'number') ? (i === typeOrIdx) : (opt === el || opt.contains(el));
    opt.classList.toggle('selected', isTarget);
    if (isTarget) selectedOfferIdx = i;
  });

  const selectedOpt = document.querySelector('.offer-opt.selected');
  if (!selectedOpt) return;

  const shipNote = document.getElementById('shipBanner') || document.getElementById('freeShipNote');
  const ctaBtn = document.getElementById('bbCtaBtn') || document.getElementById('mainCta');

  // Read attributes dynamically from Liquid HTML instead of hardcoded strings
  const showFreeShip = selectedOpt.getAttribute('data-freeship') === 'true';
  const ctaText = selectedOpt.getAttribute('data-cta-text');
  const qty = selectedOpt.getAttribute('data-qty') || '1';
  const variantId = selectedOpt.getAttribute('data-variant-id');
  const secondaryVariantId = selectedOpt.getAttribute('data-secondary-variant-id');
  const isDuo = selectedOpt.getAttribute('data-is-duo') === 'true';

  if (shipNote) {
    shipNote.style.display = showFreeShip ? 'block' : 'none';
  }

  if (ctaBtn) {
    if (ctaText) ctaBtn.innerHTML = ctaText;
    if (qty) ctaBtn.setAttribute('data-qty', qty);
    if (variantId) ctaBtn.setAttribute('data-variant-id', variantId);
    
    if (secondaryVariantId) {
      ctaBtn.setAttribute('data-secondary-variant-id', secondaryVariantId);
    } else {
      ctaBtn.removeAttribute('data-secondary-variant-id');
    }

    ctaBtn.setAttribute('data-is-duo', isDuo ? 'true' : 'false');
  }
}

// 4. UNIFIED FAQ ACCORDION
document.addEventListener('click', function(e) {
  // Find click on either .faq-q (PDP) or .faq-btn (Section)
  const header = e.target.closest('.faq-q, .faq-btn');
  if (!header || header.closest('[onclick*="toggleFaq"]')) return;

  const faqItem = header.closest('.faq-item');
  if (!faqItem) return;

  // Toggle .open class on the container
  const isOpen = faqItem.classList.toggle('open');
  header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});

// 5. STICKY MOBILE BAR OBSERVER
document.addEventListener('DOMContentLoaded', function() {
  const mobBar = document.getElementById('mobBar') || document.querySelector('.mob-bar');
  const heroBuybox = document.getElementById('bbHero') || document.querySelector('.buybox-side');

  if (mobBar && heroBuybox && window.IntersectionObserver) {
    const observer = new IntersectionObserver(([entry]) => {
      mobBar.style.display = entry.isIntersecting ? 'none' : 'block';
    }, { threshold: 0.05 });
    observer.observe(heroBuybox);
  }
});

// 6. PDP CART PERSISTENCE & SHOPIFY AJAX SYNC
function addToCartPDP() {
  const ctaBtn = document.getElementById('bbCtaBtn') || document.getElementById('mainCta');
  if (!ctaBtn) return;

  const qty = parseInt(ctaBtn.getAttribute('data-qty') || '1', 10);
  const variantId = ctaBtn.getAttribute('data-variant-id');
  const secondaryVariantId = ctaBtn.getAttribute('data-secondary-variant-id');
  const isDuo = ctaBtn.getAttribute('data-is-duo') === 'true';
  const handle = (ctaBtn.getAttribute('data-handle') || 'shine').toLowerCase();

  const primaryKey = handle.includes('somnia') ? 'somnia' : 'shine';
  const secondaryKey = primaryKey === 'shine' ? 'somnia' : 'shine';

  if (isDuo) {
    if (typeof addBundle === 'function') {
      addBundle(primaryKey === 'somnia' ? variantId : secondaryVariantId, primaryKey === 'shine' ? variantId : secondaryVariantId);
    } else {
      console.error('Cart system script missing: addBundle() not found');
    }
  } else {
    if (typeof addToCart === 'function') {
      addToCart(primaryKey, qty, variantId);
    } else {
      console.error('Cart system script missing: addToCart() not found');
    }
  }
}

function addBundlePDP() {
  addToCartPDP();
}

// 7. TOAST NOTIFICATIONS
function showToast(msg) {
  let toastEl = document.getElementById('pdpToast') || document.getElementById('toast');
  if (!toastEl) {
    toastEl = document.createElement('div');
    toastEl.id = 'pdpToast';
    toastEl.className = 'toast';
    toastEl.innerHTML = '<span>✓</span><span class="toast-msg"></span>';
    document.body.appendChild(toastEl);
  }
  const msgSpan = toastEl.querySelector('.toast-msg') || toastEl.querySelector('#toastMsg') || toastEl;
  msgSpan.textContent = msg;
  toastEl.classList.add('show');
  setTimeout(() => toastEl.classList.remove('show'), 3000);
}

